// extracted by mini-css-extract-plugin
module.exports = {"container":"index-container-1pzsb","inputWrap":"index-inputWrap-3W1qu","phoneInput":"index-phoneInput-1TVZ9","codeInput":"index-codeInput-3Y_V4","codeBtn":"index-codeBtn-3F8Kc"};